import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#6a1b6d',
    },
    secondary: {
      main: '#541858',
    },
  },
  typography: {
    fontFamily: "'DM Sans', 'Segoe UI', 'Helvetica Neue', sans-serif"
  },
});